require('./prospectPrompt.scss');

// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { Transition } = require('react-transition-group');
const PropTypes = require('prop-types');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ utils
const { formatText, FormattedText } = require('core/i18n').i18n;

class ProspectPrompt extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCloseProspectPrompt = this.handleCloseProspectPrompt.bind(this);
        this.buildPromptMessageContent = this.buildPromptMessageContent.bind(this);
    }

    componentDidMount() {
        const { disclaimerClosed, immPromptNotification, setProspectDisclaimerPrompt } = this.props;
        if (immPromptNotification && !disclaimerClosed && !immPromptNotification.get('isCollectivePromptNotification')) {
            setTimeout(() => {
                setProspectDisclaimerPrompt();
            }, 2500);
        }
    }

    componentWillUnmount() {
        const { disclaimerClosed, immPromptNotification, setProspectDisclaimerPrompt } = this.props;
        if (immPromptNotification && !disclaimerClosed && !immPromptNotification.get('isCollectivePromptNotification')) {
            setProspectDisclaimerPrompt();
        }
    }

    handleCloseProspectPrompt() {
        const { isInactiveAccount,
            onCloseButtonClick,
            setProspectDisclaimerClosed,
        } = this.props;
        if (isInactiveAccount) {
            onCloseButtonClick();
        }
        else {
            setProspectDisclaimerClosed();
        }
    }

    buildPromptMessageContent() {
        const { immPromptNotification } = this.props;
        let promptMessageContent;
        if (immPromptNotification && immPromptNotification.get('isCollectivePromptNotification')) {
            promptMessageContent = <FormattedText value={immPromptNotification.get('message')} />
        } else if (immPromptNotification) {
            promptMessageContent = (
                <div>
                    <FormattedText value={immPromptNotification.get('subtitleOne')} />
                    &nbsp;
                    <OKLink
                        modifier="emphasize"
                        to={immPromptNotification.get('url')}
                        target={immPromptNotification.get('target')}
                    >
                        <FormattedText value={immPromptNotification.get('linkInnerText')} />
                    </OKLink>
                    &nbsp;
                    <FormattedText value={immPromptNotification.get('subtitleTwo')} />
                </div>
            )
        }
        return promptMessageContent;
    }

    render() {
        const {
            disclaimerPrompt,
            inactiveTitle,
            inactiveMessage,
            immPromptNotification,
            isInactiveAccount,
        } = this.props;
        let promptTitle;
        let promptMessageContent;
        if (isInactiveAccount) {
            promptTitle = inactiveTitle;
            promptMessageContent = inactiveMessage;
        }
        else {
            promptTitle = 'prospectsPrompt-title';
            if (!!immPromptNotification && !!immPromptNotification.get('title')) {
                promptTitle = immPromptNotification.get('title');
            }
            promptTitle = formatText(promptTitle);
            promptMessageContent = this.buildPromptMessageContent();
        }

        return (
            <Transition
                appear={true}
                in={disclaimerPrompt}
                timeout={1000}
                mountOnEnter={true}
                unmountOnExit={true}
            >
                {(state) => (
                    <div className={`prospect-prompt prospect-prompt-${state}`}>
                        <OKMessage
                            key="prospectPromptMsg"
                            closeButton={true}
                            id="globalPositionProspectsPromptMsg"
                            modifier="dark-bg"
                            onCloseButtonClick={this.handleCloseProspectPrompt}
                            title={promptTitle}
                            visible={true}
                        >
                            {promptMessageContent}
                        </OKMessage>
                    </div>
                )}
            </Transition>
        );
    }
}

ProspectPrompt.propTypes = {
    isInactiveAccount: PropTypes.bool,
    inactiveTitle: PropTypes.object,
    inactiveMessage: PropTypes.object,
    disclaimerClosed: PropTypes.bool,
    disclaimerPrompt: PropTypes.bool,
    immPromptNotification: PropTypes.object,
    setProspectDisclaimerClosed: PropTypes.func,
    onCloseButtonClick: PropTypes.func,
    setProspectDisclaimerPrompt: PropTypes.func
};

module.exports = ProspectPrompt;
